module.exports = __webpack_public_path__ + "static/media/promo-winter.1d73d9a0.png";